import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, urlFichier } from '../api';
import { IconeCorbeille, IconeCrayon } from '../components/Icones';

const FORM_VIDE = {
  nom_produit: '', type_financement: 'achat', type_neuf_occasion: 'Neuf', commentaire: '',
  montant_financement: '', duree_financement: '',
  valeur_residuelle: '1', taux_commission: '', retribution_apporteur: '0',
  date_echeance: '', apporteur_id: '', vendeur_id: '',
  frais_dossier: '0', premier_loyer_plm: '0', date_livraison: '', note: '',
  organisme_financier: '', statut_projet: '', montant_a_facturer: '', date_confirmation: '',
  gere_par_id: '',
};

const STATUT_PROJET_CONFIG = {
  'En attente':    { bg: '#fef3c7', text: '#92400e', border: '#fcd34d', emoji: '⏳' },
  'Gagné':         { bg: '#d1fae5', text: '#065f46', border: '#6ee7b7', emoji: '🏆' },
  'Accord envoyé': { bg: '#dbeafe', text: '#1e40af', border: '#93c5fd', emoji: '📋' },
  'Gagné facturé': { bg: '#cffafe', text: '#155e75', border: '#67e8f9', emoji: '🧾' },
  'Perdu':         { bg: '#fee2e2', text: '#991b1b', border: '#fca5a5', emoji: '❌' },
};

const TYPE_FIN_COLORS = {
  'achat':               { bg: '#dbeafe', text: '#1d4ed8' },
  'crédit-bail':         { bg: '#ede9fe', text: '#7c3aed' },
  'location financière': { bg: '#d1fae5', text: '#059669' },
};

const NO_CACHE = { headers: { 'Cache-Control': 'no-store, no-cache', 'Pragma': 'no-cache' } };

function BanqueSearchSelect({ banques, value, onChange, onNomChange, inputStyle }) {
  const sorted = [...banques].sort((a, b) => a.nom.localeCompare(b.nom, 'fr'));
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = sorted.find(b => String(b.id) === String(value));
  const filtered = sorted.filter(b => b.nom.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setQuery(''); } };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <input
          value={open ? query : (selected ? selected.nom : query)}
          onChange={e => { setQuery(e.target.value); onChange(''); onNomChange(''); if (!open) setOpen(true); }}
          onFocus={() => { setOpen(true); setQuery(''); }}
          placeholder="Rechercher une banque partenaire…"
          style={{ ...inputStyle, paddingRight: selected ? '30px' : '14px' }}
        />
        {selected && (
          <button onMouseDown={e => { e.stopPropagation(); onChange(''); onNomChange(''); setQuery(''); setOpen(false); }}
            style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '13px', padding: 0 }}>✕</button>
        )}
      </div>
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 2px)', left: 0, right: 0, zIndex: 300, background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: '200px', overflowY: 'auto' }}>
          <div onMouseDown={() => { onChange(''); onNomChange(''); setQuery(''); setOpen(false); }}
            style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.background = 'white'}>
            — Aucune —
          </div>
          {filtered.length === 0
            ? <div style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', fontStyle: 'italic' }}>Aucun résultat</div>
            : filtered.map(b => (
              <div key={b.id} onMouseDown={() => { onChange(String(b.id)); onNomChange(b.nom); setQuery(''); setOpen(false); }}
                style={{ padding: '9px 12px', fontSize: '13px', color: '#1a2b4a', cursor: 'pointer', fontWeight: String(b.id) === String(value) ? '600' : '400', background: String(b.id) === String(value) ? '#eff6ff' : 'white' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={e => e.currentTarget.style.background = String(b.id) === String(value) ? '#eff6ff' : 'white'}>
                {b.nom}
              </div>
            ))
          }
        </div>
      )}
    </div>
  );
}

const numProjet = (id) => `PRJ-${String(id).padStart(3, '0')}`;

const mapProjetToForm = (p) => ({
  nom_produit: p.nom_produit || p.materiel || '',
  type_financement: p.type_financement || 'achat',
  type_neuf_occasion: p.type_neuf_occasion || 'Neuf',
  commentaire: p.commentaire || '',
  montant_financement: p.montant_financement != null ? String(p.montant_financement) : '',
  duree_financement: p.duree_financement != null ? String(p.duree_financement) : '',
  valeur_residuelle: p.valeur_residuelle != null ? String(p.valeur_residuelle) : '1',
  taux_commission: p.taux_commission != null ? String(p.taux_commission) : '',
  retribution_apporteur: p.retribution_apporteur != null ? String(p.retribution_apporteur) : '0',
  date_echeance: p.date_echeance || '',
  apporteur_id: p.apporteur_id != null ? String(p.apporteur_id) : '',
  vendeur_id: p.vendeur_id != null ? String(p.vendeur_id) : '',
  frais_dossier: p.frais_dossier != null ? String(p.frais_dossier) : '0',
  premier_loyer_plm: p.premier_loyer_plm != null ? String(p.premier_loyer_plm) : '0',
  date_livraison: p.date_livraison || '',
  note: p.note || '',
  organisme_financier: p.organisme_financier || '',
  statut_projet: p.statut_projet || '',
  montant_a_facturer: p.montant_a_facturer != null ? String(p.montant_a_facturer) : '',
  date_confirmation: p.date_confirmation || '',
  gere_par_id: p.gere_par_id != null ? String(p.gere_par_id) : '',
});

function ApporteurSearchSelect({ apporteurs, value, onChange, inputStyle }) {
  const sorted = [...apporteurs].sort((a, b) => a.nom_societe.localeCompare(b.nom_societe, 'fr'));
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedApporteur = sorted.find(a => String(a.id) === String(value));
  const filtered = sorted.filter(a => a.nom_societe.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSelect = (a) => {
    onChange(String(a.id));
    setQuery('');
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
    setQuery('');
    setOpen(false);
  };

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <input
          value={open ? query : (selectedApporteur ? selectedApporteur.nom_societe : query)}
          onChange={e => { setQuery(e.target.value); onChange(''); if (!open) setOpen(true); }}
          onFocus={() => { setOpen(true); setQuery(''); }}
          placeholder="Rechercher un apporteur…"
          style={{ ...inputStyle, paddingRight: selectedApporteur ? '30px' : '12px' }}
        />
        {selectedApporteur && (
          <button onMouseDown={handleClear}
            style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '13px', padding: 0, lineHeight: 1 }}>
            ✕
          </button>
        )}
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 2px)', left: 0, right: 0, zIndex: 200,
          background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: '200px', overflowY: 'auto',
        }}>
          <div
            onMouseDown={() => { onChange(''); setQuery(''); setOpen(false); }}
            style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.background = 'white'}>
            — Aucun —
          </div>
          {filtered.length === 0 ? (
            <div style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', fontStyle: 'italic' }}>Aucun résultat</div>
          ) : (
            filtered.map(a => (
              <div key={a.id}
                onMouseDown={() => handleSelect(a)}
                style={{ padding: '8px 12px', fontSize: '13px', color: '#1a2b4a', cursor: 'pointer', fontWeight: String(a.id) === String(value) ? '600' : '400', background: String(a.id) === String(value) ? '#eff6ff' : 'white' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={e => e.currentTarget.style.background = String(a.id) === String(value) ? '#eff6ff' : 'white'}>
                {a.nom_societe}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

function VendeurSearchSelect({ vendeurs, value, onChange, inputStyle }) {
  const sorted = [...vendeurs].sort((a, b) => a.nom.localeCompare(b.nom, 'fr'));
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedVendeur = sorted.find(v => String(v.id) === String(value));
  const filtered = sorted.filter(v => v.nom.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSelect = (v) => {
    onChange(String(v.id));
    setQuery('');
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
    setQuery('');
    setOpen(false);
  };

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <input
          value={open ? query : (selectedVendeur ? selectedVendeur.nom : query)}
          onChange={e => { setQuery(e.target.value); onChange(''); if (!open) setOpen(true); }}
          onFocus={() => { setOpen(true); setQuery(''); }}
          placeholder="Rechercher un vendeur…"
          style={{ ...inputStyle, paddingRight: selectedVendeur ? '30px' : '12px' }}
        />
        {selectedVendeur && (
          <button onMouseDown={handleClear}
            style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '13px', padding: 0, lineHeight: 1 }}>
            ✕
          </button>
        )}
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 2px)', left: 0, right: 0, zIndex: 200,
          background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: '200px', overflowY: 'auto',
        }}>
          <div
            onMouseDown={() => { onChange(''); setQuery(''); setOpen(false); }}
            style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.background = 'white'}>
            — Aucun —
          </div>
          {filtered.length === 0 ? (
            <div style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', fontStyle: 'italic' }}>Aucun résultat</div>
          ) : (
            filtered.map(v => (
              <div key={v.id}
                onMouseDown={() => handleSelect(v)}
                style={{ padding: '8px 12px', fontSize: '13px', color: '#1a2b4a', cursor: 'pointer', fontWeight: String(v.id) === String(value) ? '600' : '400', background: String(v.id) === String(value) ? '#eff6ff' : 'white' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={e => e.currentTarget.style.background = String(v.id) === String(value) ? '#eff6ff' : 'white'}>
                {v.nom}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

function Projets({ prospectId, nomSociete, user }) {
  const navigate = useNavigate();
  const [projets, setProjets] = useState([]);
  // Les dossiers de financement de l'entreprise : un projet dont un dossier est
  // issu l'affiche, pour qu'on voie d'un coup d'œil où en est l'affaire sans
  // avoir à ouvrir le suivi des dossiers.
  const [dossiersEntreprise, setDossiersEntreprise] = useState([]);
  const [apporteurs, setApporteurs] = useState([]);
  const [vendeurs, setVendeurs] = useState([]);
  const [banques, setBanques] = useState([]);
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(FORM_VIDE);
  const [fichiers, setFichiers] = useState([]);
  const fichierRef = useRef(null);
  const [modalGagne, setModalGagne] = useState(null); // { projetId, statut }
  const [modalForm, setModalForm] = useState({ montant_a_facturer: '', date_confirmation: '', banque_finale_id: '', banque_finale_nom: '' });
  const [modalSaving, setModalSaving] = useState(false);
  const [modalAccord, setModalAccord] = useState(null); // { projet, prospect, contacts }
  const [modalPerdu, setModalPerdu] = useState(null); // projetId | null
  const [motifPerduSelect, setMotifPerduSelect] = useState('');
  const [motifPerduLibre, setMotifPerduLibre] = useState('');
  const [accordEmailClient, setAccordEmailClient] = useState('');
  const [accordEmailGarage, setAccordEmailGarage] = useState('');
  const [accordSending, setAccordSending] = useState(false);
  const [accordResult, setAccordResult] = useState(null);

  useEffect(() => {
    if (prospectId) {
      axios.get(`/api/projets/${prospectId}`, NO_CACHE)
        .then(res => setProjets(res.data))
        .catch(() => setProjets([]));
      axios.get(`/api/prospects/${prospectId}/dossiers`, NO_CACHE)
        .then(res => setDossiersEntreprise(res.data))
        .catch(() => setDossiersEntreprise([]));
    }
    axios.get('/api/prospects', NO_CACHE)
      .then(res => setApporteurs(res.data.filter(p => p.type === 'apporteur')))
      .catch(() => setApporteurs([]));
    axios.get('/api/vendeurs', NO_CACHE)
      .then(res => setVendeurs(res.data))
      .catch(() => setVendeurs([]));
    axios.get('/api/banques')
      .then(res => setBanques(res.data))
      .catch(() => setBanques([]));
    axios.get('/api/utilisateurs/attribuables')
      .then(res => setUtilisateurs(res.data))
      .catch(() => setUtilisateurs([]));
  }, [prospectId]);

  const commissionPercue = ((parseFloat(form.taux_commission) || 0) / 100) * (parseFloat(form.montant_financement) || 0);
  const commissionNette = commissionPercue - (parseFloat(form.retribution_apporteur) || 0);

  const isAffaireChaude = (dateStr) => {
    if (!dateStr) return false;
    const ech = new Date(dateStr); ech.setHours(23, 59, 59, 0);
    const jours = Math.ceil((ech - new Date()) / 86400000);
    return jours >= 0 && jours <= 120;
  };

  const calcCommNette = (p) => {
    const base = p.montant_financement ?? p.prix_produit ?? 0;
    const comm = ((p.taux_commission || 0) / 100) * base;
    return comm - (p.retribution_apporteur || 0);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('fr-FR');
  };

  const formatMoney = (val) => {
    if (val === null || val === undefined || val === '') return '—';
    return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
  };

  const getNomApporteur = (id) => {
    if (!id) return null;
    const a = apporteurs.find(a => a.id === id);
    return a ? a.nom_societe : null;
  };

  const getNomVendeur = (id) => {
    if (!id) return null;
    const v = vendeurs.find(v => v.id === id);
    return v ? v.nom : null;
  };

  const getPiecesJointes = (p) => {
    try { return JSON.parse(p.pieces_jointes || '[]'); }
    catch { return []; }
  };

  const openNewForm = () => {
    setEditingId(null);
    setForm(FORM_VIDE);
    setFichiers([]);
    if (fichierRef.current) fichierRef.current.value = '';
    setShowForm(true);
  };

  const openEditForm = (p) => {
    setEditingId(p.id);
    setForm(mapProjetToForm(p));
    setFichiers([]);
    if (fichierRef.current) fichierRef.current.value = '';
    setShowForm(true);
  };

  const handleSubmit = async () => {
    if (!form.nom_produit) return alert('Le nom du produit est obligatoire');
    const payload = {
      materiel: form.nom_produit,
      valeur_ht: parseFloat(form.montant_financement) || 0,
      nom_produit: form.nom_produit,
      type_financement: form.type_financement,
      type_neuf_occasion: form.type_neuf_occasion,
      commentaire: form.commentaire || null,
      montant_financement: parseFloat(form.montant_financement) || null,
      duree_financement: parseInt(form.duree_financement) || null,
      valeur_residuelle: parseFloat(form.valeur_residuelle) || 1,
      taux_commission: parseFloat(form.taux_commission) || null,
      retribution_apporteur: parseFloat(form.retribution_apporteur) || 0,
      date_echeance: form.date_echeance || null,
      apporteur_id: parseInt(form.apporteur_id) || null,
      vendeur_id: parseInt(form.vendeur_id) || null,
      frais_dossier: parseFloat(form.frais_dossier) || 0,
      premier_loyer_plm: parseFloat(form.premier_loyer_plm) || 0,
      date_livraison: form.date_livraison || null,
      note: form.note || null,
      organisme_financier: form.organisme_financier || null,
      statut_projet: form.statut_projet || null,
      montant_a_facturer: parseFloat(form.montant_a_facturer) || null,
      date_confirmation: form.date_confirmation || null,
    };

    try {
      let savedProjet;
      if (editingId) {
        const res = await axios.put(`/api/projets/${editingId}`, { ...payload, gere_par_id: parseInt(form.gere_par_id) || null });
        savedProjet = res.data;
        setProjets(prev => prev.map(p => p.id === editingId ? savedProjet : p));
      } else {
        const res = await axios.post('/api/projets', { ...payload, prospect_id: prospectId, cree_par_id: user?.id || null, gere_par_id: parseInt(form.gere_par_id) || null });
        savedProjet = res.data;
        setProjets(prev => [...prev, savedProjet]);
      }

      if (fichiers.length > 0) {
        const fd = new FormData();
        fichiers.forEach(f => fd.append('files', f));
        const res = await axios.post(`/api/projets/${savedProjet.id}/pieces-jointes`, fd);
        setProjets(prev => prev.map(p => p.id === savedProjet.id ? res.data : p));
      }

      setShowForm(false);
      setEditingId(null);
      setForm(FORM_VIDE);
      setFichiers([]);
      if (fichierRef.current) fichierRef.current.value = '';
    } catch (e) {
      alert('Erreur lors de l\'enregistrement');
    }
  };

  const supprimerProjet = (projet) => {
    const nom = projet.materiel || projet.nom_produit || `projet n° ${projet.id}`;
    if (window.confirm(`Supprimer cette affaire ?\n\n${nom}${nomSociete ? ` — ${nomSociete}` : ''}\n\nSi un dossier de financement en est issu, il restera, et comptera seul dans les affaires chaudes.`)) {
      axios.delete(`/api/projets/${projet.id}`)
        .then(() => setProjets(prev => prev.filter(p => p.id !== projet.id)))
        .catch(err => alert(err.response?.data?.detail || 'La suppression a échoué.'));
    }
  };

  const ouvrirModalPerdu = (projet) => {
    setModalPerdu(projet.id);
    setMotifPerduSelect('');
    setMotifPerduLibre('');
  };

  const confirmerPerdu = async () => {
    const motif = motifPerduSelect === 'Autre' ? motifPerduLibre.trim() : motifPerduSelect;
    if (!motif) return;
    try {
      await axios.patch(`/api/projets/${modalPerdu}/statut_projet`, {
        statut: 'Perdu',
        motif_perte: motif,
      });
      setProjets(prev => prev.map(p => p.id === modalPerdu ? { ...p, statut_projet: 'Perdu', motif_perte: motif } : p));
      setModalPerdu(null);
    } catch { alert('Erreur lors de la mise à jour'); }
  };

  const ouvrirModalGagne = (projet, statut) => {
    setModalGagne({ projetId: projet.id, statut });
    setModalForm({
      montant_a_facturer: projet.montant_a_facturer != null ? String(projet.montant_a_facturer) : '',
      date_confirmation: projet.date_confirmation || new Date().toISOString().slice(0, 10),
      banque_finale_id: projet.banque_finale_id ? String(projet.banque_finale_id) : '',
      banque_finale_nom: projet.banque_finale_nom || '',
    });
  };

  const confirmerGagne = async () => {
    if (!modalGagne) return;
    setModalSaving(true);
    try {
      const projet = projets.find(p => p.id === modalGagne.projetId);
      const payload = {
        ...mapProjetToForm(projet),
        statut_projet: modalGagne.statut,
        montant_a_facturer: parseFloat(modalForm.montant_a_facturer) || null,
        date_confirmation: modalForm.date_confirmation || null,
        banque_finale_id: modalForm.banque_finale_id ? parseInt(modalForm.banque_finale_id) : null,
        banque_finale_nom: modalForm.banque_finale_nom || null,
        montant_financement: parseFloat(mapProjetToForm(projet).montant_financement) || null,
        duree_financement: parseInt(mapProjetToForm(projet).duree_financement) || null,
        valeur_residuelle: parseFloat(mapProjetToForm(projet).valeur_residuelle) || 1,
        taux_commission: parseFloat(mapProjetToForm(projet).taux_commission) || null,
        retribution_apporteur: parseFloat(mapProjetToForm(projet).retribution_apporteur) || 0,
        apporteur_id: parseInt(mapProjetToForm(projet).apporteur_id) || null,
        vendeur_id: parseInt(mapProjetToForm(projet).vendeur_id) || null,
        frais_dossier: parseFloat(mapProjetToForm(projet).frais_dossier) || 0,
        premier_loyer_plm: parseFloat(mapProjetToForm(projet).premier_loyer_plm) || 0,
        materiel: projet.nom_produit || projet.materiel || '',
        valeur_ht: parseFloat(mapProjetToForm(projet).montant_financement) || 0,
        nom_produit: projet.nom_produit || projet.materiel || '',
      };
      const res = await axios.put(`/api/projets/${modalGagne.projetId}`, payload);
      setProjets(prev => prev.map(p => p.id === modalGagne.projetId ? res.data : p));
      setModalGagne(null);
    } catch (e) {
      alert('Erreur lors de la mise à jour');
    }
    setModalSaving(false);
  };

  const supprimerFichier = async (projet, filename) => {
    if (!window.confirm(`Supprimer "${filename.replace(/^\d+_/, '')}" ?`)) return;
    const res = await axios.delete(`/api/projets/${projet.id}/pieces-jointes/${filename}`);
    setProjets(prev => prev.map(p => p.id === projet.id ? res.data : p));
  };

  const ouvrirModalAccord = async (p) => {
    try {
      const [prospectRes, contactsRes] = await Promise.all([
        axios.get(`/api/prospects/${p.prospect_id}`, NO_CACHE),
        axios.get(`/api/prospects/${p.prospect_id}/contacts`, NO_CACHE),
      ]);
      const contacts = contactsRes.data;
      const firstEmail = contacts.find(c => c.type === 'email')?.valeur || prospectRes.data.email || '';
      setAccordEmailClient(firstEmail);
      setAccordEmailGarage('');
      setAccordResult(null);
      setModalAccord({ projet: p, prospect: prospectRes.data, contacts });
    } catch {
      alert('Erreur lors du chargement des données');
    }
  };

  const telechargerAccordPdf = async () => {
    if (!modalAccord) return;
    const token = localStorage.getItem('token');
    const res = await fetch(
      `/api/projets/${modalAccord.projet.id}/accord-financement/pdf`,
      { cache: 'no-store', headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) { alert('Erreur lors de la génération du PDF'); return; }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `accord_financement_PRJ-${String(modalAccord.projet.id).padStart(3, '0')}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const envoyerAccord = async () => {
    if (!accordEmailClient.trim() && !accordEmailGarage.trim()) {
      return alert('Veuillez saisir au moins un email destinataire');
    }
    setAccordSending(true);
    setAccordResult(null);
    try {
      const res = await axios.post(
        `/api/projets/${modalAccord.projet.id}/accord-financement/envoyer`,
        { email_client: accordEmailClient.trim(), email_garage: accordEmailGarage.trim() }
      );
      setAccordResult(res.data);
      if (res.data?.detail?.some(r => r.statut === 'success')) {
        await axios.patch(`/api/projets/${modalAccord.projet.id}/statut_projet`, { statut: 'Accord envoyé' });
        setProjets(prev => prev.map(p => p.id === modalAccord.projet.id ? { ...p, statut_projet: 'Accord envoyé' } : p));
      }
    } catch (e) {
      alert('Erreur lors de l\'envoi : ' + (e.response?.data?.detail || e.message));
    }
    setAccordSending(false);
  };

  const inputStyle = {
    padding: '8px 12px', borderRadius: '8px', border: '1px solid #e5e7eb',
    fontSize: '13px', outline: 'none', background: 'white', width: '100%', boxSizing: 'border-box'
  };

  const labelStyle = {
    display: 'block', marginBottom: '4px', fontSize: '11px', fontWeight: '600',
    color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em'
  };

  const SectionTitle = ({ children }) => (
    <div style={{
      fontSize: '11px', fontWeight: '700', color: '#1a2b4a', textTransform: 'uppercase',
      letterSpacing: '0.06em', marginBottom: '10px', marginTop: '18px', paddingBottom: '6px',
      borderBottom: '2px solid #e5e7eb'
    }}>
      {children}
    </div>
  );

  const editingProjet = editingId ? projets.find(p => p.id === editingId) : null;

  return (
    <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Projets / Besoins
          <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400', marginLeft: '8px' }}>({projets.length})</span>
        </h2>
        {!showForm && (
          <button onClick={openNewForm}
            style={{ background: '#1a2b4a', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
            + Nouveau projet
          </button>
        )}
      </div>

      {showForm && (
        <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a2b4a', marginBottom: '4px' }}>
            {editingId ? `✏️ Modifier ${numProjet(editingId)}` : '+ Nouveau projet'}
          </div>

          <SectionTitle>Produit</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Nom du produit / matériel *</label>
              <input value={form.nom_produit} onChange={e => setForm({ ...form, nom_produit: e.target.value })}
                placeholder="Ex : Chariot élévateur Toyota..."
                style={{ ...inputStyle, borderColor: !form.nom_produit ? '#fca5a5' : '#e5e7eb' }} />
            </div>
            <div>
              <label style={labelStyle}>Organisme financier / banque</label>
              <input value={form.organisme_financier} onChange={e => setForm({ ...form, organisme_financier: e.target.value })}
                placeholder="Ex : BNP Paribas Leasing, Grenke..."
                style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Type de financement</label>
              <select value={form.type_financement} onChange={e => setForm({ ...form, type_financement: e.target.value })} style={inputStyle}>
                <option value="achat">Achat</option>
                <option value="crédit-bail">Crédit-bail</option>
                <option value="location financière">Location financière</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>État</label>
              <select value={form.type_neuf_occasion} onChange={e => setForm({ ...form, type_neuf_occasion: e.target.value })} style={inputStyle}>
                <option>Neuf</option>
                <option>Occasion</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Apporteur</label>
              <ApporteurSearchSelect
                apporteurs={apporteurs}
                value={form.apporteur_id}
                onChange={val => setForm(f => ({ ...f, apporteur_id: val }))}
                inputStyle={inputStyle}
              />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Commentaire</label>
              <input value={form.commentaire} onChange={e => setForm({ ...form, commentaire: e.target.value })} style={inputStyle} />
            </div>
          </div>

          <SectionTitle>Financement</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Montant financement (€)</label>
              <input type="number" min="0" value={form.montant_financement}
                onChange={e => setForm({ ...form, montant_financement: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Durée (mois)</label>
              <input type="number" min="1" value={form.duree_financement}
                onChange={e => setForm({ ...form, duree_financement: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Valeur résiduelle (%)</label>
              <input type="number" min="0" max="100" step="0.1" value={form.valeur_residuelle}
                onChange={e => setForm({ ...form, valeur_residuelle: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Frais de dossier (€)</label>
              <input type="number" min="0" value={form.frais_dossier}
                onChange={e => setForm({ ...form, frais_dossier: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>1er loyer PLM (€)</label>
              <input type="number" min="0" value={form.premier_loyer_plm}
                onChange={e => setForm({ ...form, premier_loyer_plm: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Date de livraison</label>
              <input type="date" value={form.date_livraison}
                onChange={e => setForm({ ...form, date_livraison: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Date d'échéance</label>
              <input type="date" value={form.date_echeance}
                onChange={e => setForm({ ...form, date_echeance: e.target.value })} style={inputStyle} />
            </div>
          </div>

          <SectionTitle>Commission</SectionTitle>
          <div style={{ background: '#f0f7ff', padding: '16px', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '14px' }}>
              <div>
                <label style={labelStyle}>Taux commission (%)</label>
                <input type="number" min="0" max="100" step="0.1" value={form.taux_commission}
                  onChange={e => setForm({ ...form, taux_commission: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Rétribution apporteur (€)</label>
                <input type="number" min="0" value={form.retribution_apporteur}
                  onChange={e => setForm({ ...form, retribution_apporteur: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Vendeur responsable</label>
                <VendeurSearchSelect
                  vendeurs={vendeurs}
                  value={form.vendeur_id}
                  onChange={val => setForm(f => ({ ...f, vendeur_id: val }))}
                  inputStyle={inputStyle}
                />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div style={{ background: 'white', borderRadius: '8px', padding: '10px 14px', border: '1px solid #bfdbfe' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Commission brute</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#1d4ed8' }}>
                  {commissionPercue.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €
                </div>
              </div>
              <div style={{ background: 'white', borderRadius: '8px', padding: '10px 14px', border: '1px solid #bfdbfe' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Commission nette</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: commissionNette >= 0 ? '#059669' : '#ef4444' }}>
                  {commissionNette.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €
                </div>
              </div>
            </div>
          </div>

          <SectionTitle>Statut de l'affaire</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '4px' }}>
            <div>
              <label style={labelStyle}>Géré par</label>
              <select value={form.gere_par_id} onChange={e => setForm({ ...form, gere_par_id: e.target.value })} style={inputStyle}>
                <option value="">— Non assigné —</option>
                {utilisateurs.filter(u => u.actif !== false && (u.role === 'admin' || u.role === 'commercial')).map(u => (
                  <option key={u.id} value={u.id}>{u.nom}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Statut</label>
              <select value={form.statut_projet} onChange={e => setForm({ ...form, statut_projet: e.target.value })} style={inputStyle}>
                <option value="En attente">En attente</option>
                <option value="Gagné">Gagné</option>
                <option translate="no" value="Accord envoyé">Accord envoyé</option>
                <option translate="no" value="Gagné facturé">Gagné facturé</option>
                <option value="Perdu">Perdu</option>
              </select>
            </div>
            {(form.statut_projet === 'Gagné facturé') && (
              <>
                <div>
                  <label style={labelStyle}>Montant à facturer (€)</label>
                  <input type="number" min="0" value={form.montant_a_facturer}
                    onChange={e => setForm({ ...form, montant_a_facturer: e.target.value })} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Date de confirmation</label>
                  <input type="date" value={form.date_confirmation}
                    onChange={e => setForm({ ...form, date_confirmation: e.target.value })} style={inputStyle} />
                </div>
              </>
            )}
          </div>

          <SectionTitle>Note & Pièces jointes</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Note</label>
              <textarea value={form.note} onChange={e => setForm({ ...form, note: e.target.value })}
                rows={3} placeholder="Remarques, observations..."
                style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.5' }} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Ajouter des pièces jointes</label>
              <input type="file" multiple ref={fichierRef}
                onChange={e => setFichiers(Array.from(e.target.files))}
                style={{ ...inputStyle, padding: '6px 10px', cursor: 'pointer' }} />
              {fichiers.length > 0 && (
                <div style={{ marginTop: '6px', fontSize: '12px', color: '#6b7280' }}>
                  {fichiers.length} fichier{fichiers.length > 1 ? 's' : ''} sélectionné{fichiers.length > 1 ? 's' : ''}
                </div>
              )}
            </div>
            {editingProjet && getPiecesJointes(editingProjet).length > 0 && (
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ ...labelStyle, marginBottom: '8px' }}>Fichiers existants</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {getPiecesJointes(editingProjet).map(f => (
                    <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#f0f7ff', border: '1px solid #bfdbfe', borderRadius: '6px', padding: '4px 10px', fontSize: '12px' }}>
                      <a href={urlFichier(`${API}/uploads/projets/${f}`)} target="_blank" rel="noopener noreferrer"
                        style={{ color: '#1d4ed8', textDecoration: 'none' }}>{f.replace(/^\d+_/, '')}
                      </a>
                      <button onClick={() => supprimerFichier(editingProjet, f)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '12px', padding: '0', lineHeight: 1 }}>✕</button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            <button onClick={handleSubmit}
              style={{ background: '#1a2b4a', color: 'white', padding: '10px 24px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
              {editingId ? '✅ Mettre à jour' : 'Enregistrer'}
            </button>
            <button onClick={() => { setShowForm(false); setEditingId(null); setForm(FORM_VIDE); setFichiers([]); }}
              style={{ background: 'white', color: '#6b7280', padding: '10px 24px', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {projets.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af', fontSize: '14px' }}>
          Aucun projet pour ce prospect
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>
                {['N°', 'Produit', 'Financement', 'Montant / Durée', 'Comm. nette', 'Dates', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {projets.map(p => {
                const commNette = calcCommNette(p);
                const chaude = isAffaireChaude(p.date_echeance);
                const typeFin = TYPE_FIN_COLORS[p.type_financement] || { bg: '#f3f4f6', text: '#6b7280' };
                const nomApporteur = getNomApporteur(p.apporteur_id);
                const nomVendeur = getNomVendeur(p.vendeur_id);
                const pj = getPiecesJointes(p);
                return (
                  <tr key={p.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 12px', fontSize: '12px', fontWeight: '700', color: '#6366f1', whiteSpace: 'nowrap' }}>
                      {numProjet(p.id)}
                    </td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '500', color: '#1a2b4a', maxWidth: '200px' }}>
                      <div>{p.nom_produit || p.materiel}</div>
                      {p.statut_projet && STATUT_PROJET_CONFIG[p.statut_projet] && (() => {
                        const sc = STATUT_PROJET_CONFIG[p.statut_projet];
                        return (
                          <div style={{ marginTop: '4px' }}>
                            <span translate="no" style={{ background: sc.bg, color: sc.text, border: `1px solid ${sc.border}`, padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '700' }}>
                              {sc.emoji} {p.statut_projet}
                            </span>
                            {p.statut_projet === 'Perdu' && p.motif_perte && (
                              <div style={{ fontSize: '11px', color: '#991b1b', fontWeight: '600', marginTop: '2px' }}>
                                {p.motif_perte}
                              </div>
                            )}
                            {p.montant_a_facturer != null && (
                              <div style={{ fontSize: '11px', color: sc.text, fontWeight: '600', marginTop: '2px' }}>
                                {Number(p.montant_a_facturer).toLocaleString('fr-FR')} € à facturer
                              </div>
                            )}
                            {p.banque_finale_nom && (
                              <div style={{ fontSize: '11px', color: '#1e40af', fontWeight: '600', marginTop: '2px' }}>{p.banque_finale_nom}
                              </div>
                            )}
                          </div>
                        );
                      })()}
                      {p.type_neuf_occasion && (
                        <span style={{ background: p.type_neuf_occasion === 'Neuf' ? '#dbeafe' : '#fef3c7', color: p.type_neuf_occasion === 'Neuf' ? '#1d4ed8' : '#92400e', padding: '2px 7px', borderRadius: '99px', fontSize: '11px', fontWeight: '600', marginTop: '3px', display: 'inline-block' }}>
                          {p.type_neuf_occasion}
                        </span>
                      )}
                      {nomApporteur && (
                        <div style={{ fontSize: '11px', color: '#6366f1', marginTop: '3px', fontWeight: '500' }}>{nomApporteur}</div>
                      )}
                      {/* Dossier de financement issu de ce projet. Un dossier refusé
                          reste affiché : savoir qu'une demande a été refusée
                          compte autant que de savoir qu'elle est en cours. */}
                      {dossiersEntreprise.filter(d => d.projet_id === p.id).map(d => {
                        const ton = d.statut === 'Validé' ? ['#d1fae5', '#065f46', '#6ee7b7']
                                  : d.statut === 'Refusé' ? ['#fee2e2', '#991b1b', '#fca5a5']
                                  : ['#fef3c7', '#92400e', '#fde68a'];
                        return (
                          <div key={d.id} style={{ marginTop: '4px' }}>
                            <span onClick={() => navigate(`/dossier?dossier_id=${d.id}`)}
                              title="Ouvrir le dossier de financement"
                              style={{ background: ton[0], color: ton[1], border: `1px solid ${ton[2]}`,
                                       padding: '2px 8px', borderRadius: '99px', fontSize: '11px',
                                       fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                              📄 {d.numero} · {d.statut}
                            </span>
                          </div>
                        );
                      })}
                      {nomVendeur && (
                        <div style={{ fontSize: '11px', color: '#0891b2', marginTop: '2px', fontWeight: '500' }}>{nomVendeur}</div>
                      )}
                      {p.note && (
                        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px' }}>{p.note}
                        </div>
                      )}
                      {p.cree_par_nom && (
                        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>
                          👤 <span style={{ color: '#9ca3af' }}>Créé par</span> {p.cree_par_nom}
                        </div>
                      )}
                      {p.gere_par_nom && (
                        <div style={{ fontSize: '11px', color: '#1d4ed8', marginTop: '2px', fontWeight: '500' }}>{p.gere_par_nom}
                        </div>
                      )}
                      {pj.length > 0 && (
                        <div style={{ fontSize: '11px', color: '#059669', marginTop: '3px', fontWeight: '500' }}>{pj.length} fichier{pj.length > 1 ? 's' : ''}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '12px 12px' }}>
                      {p.type_financement ? (
                        <span style={{ background: typeFin.bg, color: typeFin.text, padding: '3px 9px', borderRadius: '99px', fontSize: '11px', fontWeight: '600' }}>
                          {p.type_financement}
                        </span>
                      ) : '—'}
                    </td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>
                      <div style={{ fontWeight: '600' }}>
                        {p.montant_financement ? formatMoney(p.montant_financement) : '—'}
                        {p.duree_financement && (
                          <span style={{ color: '#9ca3af', fontSize: '12px', fontWeight: '400' }}> / {p.duree_financement}m</span>
                        )}
                      </div>
                      {(p.frais_dossier > 0 || p.premier_loyer_plm > 0) && (
                        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>
                          {p.frais_dossier > 0 && <span>Frais: {formatMoney(p.frais_dossier)}</span>}
                          {p.frais_dossier > 0 && p.premier_loyer_plm > 0 && <span> · </span>}
                          {p.premier_loyer_plm > 0 && <span>PLM: {formatMoney(p.premier_loyer_plm)}</span>}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '600', color: p.taux_commission ? (commNette >= 0 ? '#059669' : '#ef4444') : '#9ca3af' }}>
                      {p.taux_commission ? formatMoney(commNette) : '—'}
                    </td>
                    <td style={{ padding: '12px 12px', fontSize: '12px', color: '#374151' }}>
                      {p.date_livraison && (
                        <div style={{ marginBottom: '4px' }}>
                          <span style={{ color: '#6b7280' }}>📦</span> {formatDate(p.date_livraison)}
                        </div>
                      )}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                        <span style={{ color: chaude ? '#ef4444' : '#374151', fontWeight: chaude ? '600' : '400' }}>
                          {p.date_echeance ? <>{formatDate(p.date_echeance)}</> : '—'}
                        </span>
                        {chaude && (
                          <span style={{ background: '#fef2f2', color: '#ef4444', padding: '2px 7px', borderRadius: '99px', fontSize: '11px', fontWeight: '700', border: '1px solid #fecaca', width: 'fit-content' }}>Affaire chaude
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ padding: '12px 10px' }}>
                      <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <button onClick={() => openEditForm(p)} title="Modifier"
                          style={{ background: '#f0f7ff', border: '1px solid #bfdbfe', color: '#1d4ed8', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}><IconeCrayon taille={15} />
                        </button>
                        {p.statut_projet !== 'Gagné' && p.statut_projet !== 'Accord envoyé' && p.statut_projet !== 'Gagné facturé' && p.statut_projet !== 'Perdu' && (
                          <button onClick={() => ouvrirModalGagne(p, 'Gagné')} title="Marquer Gagné"
                            style={{ background: '#f0fdf4', border: '1px solid #6ee7b7', color: '#065f46', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap' }}>Gagné
                          </button>
                        )}
                        {p.statut_projet !== 'Perdu' && (
                          <button onClick={() => ouvrirModalPerdu(p)} title="Marquer Perdu"
                            style={{ background: '#fff0f0', border: '1px solid #fca5a5', color: '#991b1b', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap' }}>Perdu
                          </button>
                        )}
                        {p.statut_projet === 'Accord envoyé' && (
                          <button onClick={() => ouvrirModalGagne(p, 'Gagné facturé')} title="Marquer Gagné facturé"
                            style={{ background: '#ecfeff', border: '1px solid #67e8f9', color: '#155e75', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap' }}>Facturer
                          </button>
                        )}
                        <button onClick={() => navigate(`/dossier?prospect_id=${prospectId}&projet_id=${p.id}`)} title="Créer un dossier de financement"
                          style={{ background: '#f0fdf4', border: '1px solid #86efac', color: '#15803d', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap' }}>
                          📄
                        </button>
                        {p.statut_projet === 'Gagné' && (
                          <button onClick={() => ouvrirModalAccord(p)} title="Accord de financement"
                            style={{ background: '#fdf4ff', border: '1px solid #e9d5ff', color: '#7e22ce', padding: '5px 9px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap' }}>Accord
                          </button>
                        )}
                        {user?.role === 'admin' && (
                          <button onClick={() => supprimerProjet(p)} title="Supprimer"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '15px', padding: '5px' }}><IconeCorbeille taille={15} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {/* Modal Accord de financement */}
      {modalAccord && (() => {
        const { projet, prospect } = modalAccord;
        const loyerMensuel = projet.premier_loyer_plm
          || (projet.montant_financement && projet.duree_financement
              ? projet.montant_financement / projet.duree_financement
              : null);
        const fmt = (v) => v != null ? Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €' : '—';
        const labelStyle2 = { display: 'block', fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' };
        const inputStyle2 = { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '13px', outline: 'none', boxSizing: 'border-box' };
        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '520px', maxWidth: '95vw', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>

              {/* En-tête */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div>
                  <h2 style={{ color: '#1a2b4a', fontSize: '17px', fontWeight: '700', margin: '0 0 4px' }}>Accord de financement</h2>
                  <p style={{ color: '#6b7280', fontSize: '13px', margin: 0 }}>{projet.nom_produit || projet.materiel || ''}</p>
                </div>
                <button onClick={() => setModalAccord(null)}
                  style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af', padding: '2px' }}>×</button>
              </div>

              {/* Résumé */}
              <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '16px', marginBottom: '20px', border: '1px solid #e5e7eb' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  {[
                    ['Société', prospect.nom_societe],
                    ['Dirigeant', prospect.nom_dirigeant || '—'],
                    ['Partenaire bancaire', projet.organisme_financier || '—'],
                    ['Matériel', projet.nom_produit || projet.materiel || '—'],
                    ['Montant financé', fmt(projet.montant_financement)],
                    ['Durée', projet.duree_financement ? `${projet.duree_financement} mois` : '—'],
                    ['Loyer mensuel', loyerMensuel ? fmt(loyerMensuel) : '—'],
                    ['VR', projet.valeur_residuelle ? `${projet.valeur_residuelle} %` : '—'],
                  ].map(([label, val]) => (
                    <div key={label}>
                      <div style={{ fontSize: '10px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>{label}</div>
                      <div style={{ fontSize: '13px', color: '#1a2b4a', fontWeight: '500' }}>{val}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Emails */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
                <div>
                  <label style={labelStyle2}>Email client</label>
                  <input value={accordEmailClient} onChange={e => setAccordEmailClient(e.target.value)}
                    placeholder="email@client.fr" type="email" style={inputStyle2} />
                </div>
                <div>
                  <label style={labelStyle2}>Email garage / fournisseur</label>
                  <input value={accordEmailGarage} onChange={e => setAccordEmailGarage(e.target.value)}
                    placeholder="email@garage.fr" type="email" style={inputStyle2} />
                </div>
              </div>

              {/* Résultat envoi */}
              {accordResult && (
                <div style={{ marginBottom: '16px' }}>
                  {accordResult.detail.map((r, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', borderRadius: '6px', marginBottom: '6px', background: r.statut === 'success' ? '#f0fdf4' : '#fef2f2', border: `1px solid ${r.statut === 'success' ? '#6ee7b7' : '#fecaca'}` }}>
                      <span style={{ fontSize: '14px' }}>{r.statut === 'success' ? '✅' : '❌'}</span>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: r.statut === 'success' ? '#065f46' : '#991b1b' }}>
                          {r.statut === 'success' ? 'Envoyé' : 'Échec'} — {r.email}
                        </div>
                        {r.erreur && <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '2px' }}>{r.erreur}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Boutons */}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={telechargerAccordPdf}
                  style={{ flex: 1, background: '#f8fafc', color: '#1a2b4a', border: '1px solid #e5e7eb', padding: '11px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                  ⬇ Télécharger PDF
                </button>
                <button onClick={envoyerAccord} disabled={accordSending}
                  style={{ flex: 1, background: '#7e22ce', color: 'white', border: 'none', padding: '11px', borderRadius: '8px', cursor: accordSending ? 'not-allowed' : 'pointer', fontSize: '13px', fontWeight: '600', opacity: accordSending ? 0.7 : 1 }}>
                  {accordSending ? 'Envoi...' : '✉️ Envoyer par mail'}
                </button>
              </div>

            </div>
          </div>
        );
      })()}

      {/* Modal Gagné / Gagné facturé */}
      {modalPerdu && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '380px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <h2 style={{ color: '#991b1b', fontSize: '17px', fontWeight: '600', margin: '0 0 6px' }}>Marquer comme Perdu</h2>
            <p style={{ color: '#6b7280', fontSize: '13px', margin: '0 0 20px' }}>
              {projets.find(p => p.id === modalPerdu)?.nom_produit || ''}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  Motif de perte *
                </label>
                <select value={motifPerduSelect} onChange={e => { setMotifPerduSelect(e.target.value); setMotifPerduLibre(''); }}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: `1px solid ${!motifPerduSelect ? '#fca5a5' : '#e5e7eb'}`, fontSize: '14px', outline: 'none', boxSizing: 'border-box', background: 'white' }}>
                  <option value="">— Sélectionner un motif —</option>
                  <option value="Banque rédhibitoire">Banque rédhibitoire</option>
                  <option value="Société trop jeune">Société trop jeune</option>
                  <option value="Matériel trop ancien">Matériel trop ancien</option>
                  <option value="Banque personnelle">Banque personnelle</option>
                  <option value="Autre matériel FI">Autre matériel FI</option>
                  <option value="Autre">Autre…</option>
                </select>
              </div>
              {motifPerduSelect === 'Autre' && (
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    Précisez *
                  </label>
                  <input autoFocus value={motifPerduLibre} onChange={e => setMotifPerduLibre(e.target.value)}
                    placeholder="Décrivez le motif de perte…"
                    style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: `1px solid ${!motifPerduLibre.trim() ? '#fca5a5' : '#e5e7eb'}`, fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '22px' }}>
              <button
                onClick={confirmerPerdu}
                disabled={!motifPerduSelect || (motifPerduSelect === 'Autre' && !motifPerduLibre.trim())}
                style={{ flex: 1, background: '#dc2626', color: 'white', padding: '11px', border: 'none', borderRadius: '8px', cursor: (!motifPerduSelect || (motifPerduSelect === 'Autre' && !motifPerduLibre.trim())) ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600', opacity: (!motifPerduSelect || (motifPerduSelect === 'Autre' && !motifPerduLibre.trim())) ? 0.5 : 1 }}>Confirmer la perte
              </button>
              <button onClick={() => setModalPerdu(null)}
                style={{ padding: '11px 20px', background: 'white', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {modalGagne && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '380px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <h2 translate="no" style={{ color: '#1a2b4a', fontSize: '17px', fontWeight: '600', margin: '0 0 6px' }}>
              {modalGagne.statut === 'Gagné' ? '🏆 Marquer comme Gagné' : '🧾 Marquer comme Gagné facturé'}
            </h2>
            <p style={{ color: '#6b7280', fontSize: '13px', margin: '0 0 20px' }}>
              {projets.find(p => p.id === modalGagne.projetId)?.nom_produit || ''}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  Montant à facturer (€) {modalGagne.statut === 'Gagné facturé' ? '*' : ''}
                </label>
                <input type="number" min="0" value={modalForm.montant_a_facturer}
                  onChange={e => setModalForm({ ...modalForm, montant_a_facturer: e.target.value })}
                  placeholder="Ex : 1500"
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  Date de confirmation
                </label>
                <input type="date" value={modalForm.date_confirmation}
                  onChange={e => setModalForm({ ...modalForm, date_confirmation: e.target.value })}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              {modalGagne.statut === 'Gagné facturé' && (
                <div style={{ background: '#f0f7ff', borderRadius: '10px', padding: '14px', border: '1px solid #bfdbfe' }}>
                  <div style={{ fontSize: '12px', fontWeight: '700', color: '#1e40af', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '10px' }}>Banque financière
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px' }}>Banque partenaire</label>
                    <BanqueSearchSelect
                      banques={banques}
                      value={modalForm.banque_finale_id}
                      onChange={val => setModalForm(f => ({ ...f, banque_finale_id: val }))}
                      onNomChange={nom => setModalForm(f => ({ ...f, banque_finale_nom: nom }))}
                      inputStyle={{ padding: '9px 12px', borderRadius: '8px', border: '1px solid #bfdbfe', fontSize: '13px', outline: 'none', background: 'white', width: '100%', boxSizing: 'border-box' }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '5px' }}>
                      Ou saisie libre <span style={{ fontWeight: '400', color: '#9ca3af' }}>(si non listée)</span>
                    </label>
                    <input
                      value={modalForm.banque_finale_id ? '' : modalForm.banque_finale_nom}
                      onChange={e => setModalForm(f => ({ ...f, banque_finale_nom: e.target.value, banque_finale_id: '' }))}
                      placeholder="Ex : Leasecom, Franfinance…"
                      disabled={!!modalForm.banque_finale_id}
                      style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #bfdbfe', fontSize: '13px', outline: 'none', boxSizing: 'border-box', background: modalForm.banque_finale_id ? '#f3f4f6' : 'white', color: modalForm.banque_finale_id ? '#9ca3af' : '#1a2b4a' }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '22px' }}>
              <button onClick={confirmerGagne} disabled={modalSaving}
                style={{ flex: 1, background: modalGagne.statut === 'Gagné facturé' ? '#0891b2' : '#059669', color: 'white', padding: '11px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {modalSaving ? 'Enregistrement...' : '✅ Confirmer'}
              </button>
              <button onClick={() => setModalGagne(null)}
                style={{ padding: '11px 20px', background: 'white', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Projets;
